module.exports = __webpack_public_path__ + "img/dni-frente.3c166df4.svg";